<template>
    <div>
        <a-card type="inner" size="small">
            <a-row type="flex" width="100%">
                <a-col :span="12">
                    <a-table class="pcp-table" :dataSource="items" :columns="columns" rowKey="id" :pagination="false">
                        <div slot-scope="r" slot="category" class="text-center text-small">
                            {{ r.category }}
                        </div>

                        <div slot-scope="r" slot="score" class="text-center text-small">
                            {{ r.score }}
                        </div>

                        <div slot-scope="r" slot="wom" class="text-center text-small" :style="'background-color: ' + colors['_' + r.wom]">
                            &nbsp;
                        </div>

                        <div slot-scope="r" slot="fee" class="text-center text-small">
                            {{ r.variable }}<br>
                            {{ r.note }}
                        </div>
                    </a-table>
                </a-col>
                <a-col :span="12">
                    <a-descriptions bordered>
                        <a-descriptions-item label="Business Result" span="3">
                            {{ parseFloat(breTotal).toFixed(2) }}
                        </a-descriptions-item>
                        <a-descriptions-item label="Business Process" span="3">
                            {{ parseFloat(bprTotal).toFixed(2) }}
                        </a-descriptions-item>
                        <a-descriptions-item label="Competencies" span="3">
                            {{ softTotal }}
                        </a-descriptions-item>
                        <a-descriptions-item label="Performance" span="3">
                            <a-row type="flex">
                                <a-col :span="12">
                                    {{ total }}
                                </a-col>
                                <a-col :span="12">
                                    <div :style="'background-color: ' + colors['_' + womRange]">&nbsp;</div>
                                </a-col>
                            </a-row>
                        </a-descriptions-item>
                        <a-descriptions-item label="Konversi" span="3">
                            {{ parseFloat(scoreRange).toFixed(2) }}
                        </a-descriptions-item>
                    </a-descriptions>
                </a-col>
            </a-row>
        </a-card>
    </div>
</template>

<script>
import colors from '../../../pcp/wom'

const columns = [
    {
        key: 'category',
        align: 'center',
        title: 'Kategori Penilaian',
        scopedSlots: { customRender: 'category' }
    },{
        key: 'score',
        align: 'center',
        title: 'Nilai Yudisium',
        scopedSlots: { customRender: 'score' }
    }, {
        key: 'wom',
        align: 'center',
        colSpan: 2,
        title: 'Usulan Imbalan Hasil Kinerja',
        scopedSlots: { customRender: 'wom' }
    }, {
        key: 'fee',
        align: 'center',
        colSpan: 0,
        title: '',
        scopedSlots: { customRender: 'fee' }
    },
]

export default {
    props: {
        breTotal: {
            type: Number,
            default: 0
        },
        bprTotal: {
            type: Number,
            default: 0
        },
        softTotal: {
            type: Number,
            default: 0
        }
    },
    data: () => ({
        colors,
        columns,
        items: [
            {
                category: 'Sangat memuaskan (Outstanding)',
                score: '4.33 - 5.00',
                wom: 5,
                variable: 'A+ variable',
                note: 'Outstanding'
            },
            {
                category: 'Memuaskan (Exceed Expectation)',
                score: '3.67 - 4.32',
                wom: 4,
                variable: 'A+ variable',
                note: 'Outstanding'
            },
            {
                category: 'Baik (Meet Expectation)',
                score: '3.00 - 3.66',
                wom: 3,
                variable: 'A',
                note: ''
            },
            {
                category: 'Kurang (Below Expectation)',
                score: '2.33 - 2.99',
                wom: 2,
                variable: '',
                note: 'Tidak mendapatkan imbalan kerja'
            },
            {
                category: 'Sangat Kurang (Poor)',
                score: '0.00 - 2.32',
                wom: 1,
                variable: '',
                note: 'Tidak mendapatkan imbalan kerja'
            }
        ],
    }),
    computed: {
        total() {
            return parseFloat(this.breTotal + this.bprTotal + this.softTotal).toFixed(2)
        },
        scoreRange(){
            let score = this.total

            if(score < Math.max(0.00,2.32) && score > Math.min(0.00,2.32) == true){
                return 25.8587*score
            }
            if(score < Math.max(2.33,2.99) && score > Math.min(2.33,2.99) == true){
                return (15.1364*score)+24.7323
            }
            if(score < Math.max(3.00,3.66) && score > Math.min(3.00,3.66) == true){
                return (15.1364*score) + 24.5908
            }
            if(score < Math.max(3.67,4.32) && score > Math.min(3.67,4.32) == true){
                return (15.3690*score)+23.5959
            }
            if(score < Math.max(4.33,5.00) && score > Math.min(4.33,5.00) == true){
                return (14.9253*score)+25.3735
            }

            return 0
        },
        womRange(){
            let score = this.total

            if(score < Math.max(0.00,2.32) && score > Math.min(0.00,2.32) == true){
                return 1
            }
            if(score < Math.max(2.33,2.99) && score > Math.min(2.33,2.99) == true){
                return 2
            }
            if(score < Math.max(3.00,3.66) && score > Math.min(3.00,3.66) == true){
                return 3
            }
            if(score < Math.max(3.67,4.32) && score > Math.min(3.67,4.32) == true){
                return 4
            }
            if(score < Math.max(4.33,5.00) && score > Math.min(4.33,5.00) == true){
                return 5
            }
        },
    }
}
</script>